module.exports = __webpack_public_path__ + "assets/img/tit5.22ed95ff.png";